import React, { useEffect, useState } from "react";
import { API_URL, authFetch } from "../../utils/auth";
import "../../../css/partner/LeadOverview.css";

export default function LeadOverview() {
  const [leads, setLeads] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function load() {
      try {
        const res = await authFetch(`${API_URL}/partner/leads-overview/`);
        const data = await res.json();

        setLeads(Array.isArray(data) ? data : []);
      } catch (err) {
        console.error(err);
      } finally {
        setLoading(false);
      }
    }

    load();
  }, []);

  return (
    <div className="card">
      <div className="card-title">Leads Overview</div>

      <table className="table">
        <thead>
          <tr>
            <th>Lead</th>
            <th>Business</th>
            <th>Status</th>
            <th>Value</th>
          </tr>
        </thead>

        <tbody>
          {loading ? (
            <tr>
              <td colSpan="4" style={{ textAlign: "center" }}>
                Loading leads...
              </td>
            </tr>
          ) : leads.length === 0 ? (
            <tr>
              <td colSpan="4" style={{ textAlign: "center", padding: "20px" }}>
                No leads yet
              </td>
            </tr>
          ) : (
            leads.map((l, i) => (
              <tr key={i}>
                <td>{l.name}</td>
                <td>{l.business}</td>
                <td>
                  <span className="badge">{l.status}</span>
                </td>
                <td>
                  <div>{l.value_display}</div>
                  {l.value_subtext && (
                    <small className="text-muted">
                      {l.value_subtext}
                    </small>
                  )}
                </td>
              </tr>
            ))
          )}
        </tbody>
      </table>
    </div>
  );
}